import { isValidCurrency } from './stringUtils';

type ExtraOptionsType = Intl.NumberFormatOptions & { removeCurrency?: boolean };

export const promoPriceToSRP = (
  num?: number | null,
  showSRP: boolean = true
) => {
  let retailPrice = num || 0;
  const toAddIfSRP = retailPrice * 0.12;

  if (showSRP) {
    retailPrice = retailPrice + toAddIfSRP;
    // retailPrice = Math.round(retailPrice);
  }
  return retailPrice;
};

export const isNormalInteger = (str: string | number | undefined) => {
  if (str === 1 || str === '1') {
    return true;
  }
  const n = Math.floor(Number(str));
  return n !== Infinity && String(n) === str && n >= 0;
};

export const getNumberOrZero = (param: number | undefined | null) => {
  return param || 0;
};

export const formatCurrencyCSV = (amount: any) => {
  if (typeof amount !== 'number') {
    if (isValidCurrency(amount)) {
      formatCurrency(+amount);
    } else {
      return '';
    }
  }

  if (amount === null || amount === undefined) {
    return '';
  }

  const formatter = new Intl.NumberFormat('en-PH', {
    minimumFractionDigits: 2
  });
  return formatter.format(amount);
};

// Tread lightly check peso sign on transaction slip if you're going to change this.
export const formatCurrency = (
  amount: any,
  // eslint-disable-next-line no-unused-vars
  symbol: string = '₱',
  decimal = 2,
  extraOptions?: ExtraOptionsType
) => {
  // Sometimes, 'strings' can still pass amount type.
  // and will error TypeError: amount.toFixed is not a function
  // in that case convert amount params type into number
  if (typeof amount !== 'number') {
    if (isValidCurrency(amount)) {
      formatCurrency(+amount);
    } else {
      return '';
    }
  }
  if (amount === null || amount === undefined) {
    return '';
  }
  // Create our number formatter.
  const formatter = new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: decimal,
    ...extraOptions
  });

  let currencyInStr = `${formatter.format(amount)}`;

  if (extraOptions?.removeCurrency && amount >= 0) {
    currencyInStr = currencyInStr.substring(1);
  }

  if (extraOptions?.removeCurrency && amount < 0) {
    currencyInStr = currencyInStr.substring(2);
    currencyInStr = `-${currencyInStr}`;
  }

  return currencyInStr;
};

export const getRandomInt = (min: number = 654, max: number = 987) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const between = (x: number, min: number, max: number) => {
  return x >= min && x <= max;
};

export const removeNonDigits = (input: string): string =>
  input?.replace(/\D/g, '');

export const srpPercentageToNumber = (
  srpValue: string | null = null
): number => {
  if (!srpValue) return 0;

  const numericValue = srpValue.replace('%', '');
  if (numericValue === '-1') return -1;

  const parsed = parseFloat(numericValue);
  return isNaN(parsed) ? 0 : parsed / 100;
};

export const calculateMarginPercentage = (dp: number = 0, rp: number = 0) => {
  if (rp === 0) return 0; // avoid division by zero
  const margin = ((rp - dp) / rp) * 100;
  return isNaN(margin) ? 0 : parseFloat(margin.toFixed(2)); // returns percentage rounded to 2 decimal places
};

/** ========== Start of functions for calculations of Tax related stuff ========== **/
const vat_rate = 0.12;
const withholdingRate = 0.01;

export const computeVatAmount = (totalSales: number = 0): number => {
  return +(totalSales - totalSales / (1 + vat_rate))?.toFixed(2);
};

export const computeNetOfVat = (totalSales: number): number => {
  return +(totalSales / (1 + vat_rate))?.toFixed(2);
};

export const computeWithholdingTax = (totalSales: number): number => {
  return +(computeNetOfVat(totalSales) * withholdingRate).toFixed(2);
};

export const anyToNumber = (val: any): number => {
  if (val == null) return 0;

  if (typeof val === 'number' && !isNaN(val)) {
    return val;
  }

  if (typeof val === 'string') {
    // remove anything that's not a digit, dot, or minus sign
    const cleaned = val.replace(/[^\d.-]/g, '');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  return 0;
};

export const decimalToPercent = (decimal: number | undefined) => {
  return decimal != null ? decimal * 100 : null;
};

export const percentToDecimal = (percent: number) => {
  return percent / 100;
};

export const parsePercentage = (value?: string) => {
  if (!value) return 0;
  return parseFloat(value.replace('%', ''));
};
